// What a reader is looking at: the view the current database is read through.
//
// Russell, trying the workspace switcher: "but instead of 'Ultimate Plus' you
// should show the view". A reader's context is the workspace, the library and
// the view that applies to them - never a plan. Where they hold more than one
// view for the library, the bar is where they choose which.
//
// The view comes from the configuration the app already loads
// (GET /processes/view-config carries `view: { name, builtIn }` when one
// applies, backend/services/viewConfig.js applyView): no endpoint is added
// and no name is hard-coded here - not even the built-in "All objects",
// whose name travels with it.
//
// Where no view applies - bpExperts staff, or a workspace admin holding no
// view for this database - the screens say so plainly rather than inventing
// a name.

// Said where nothing applies. Plain, and true: without a view the reader sees
// every object type the database shows.
export const NO_VIEW = "No view - you see every object type";

export const viewName = (view) => (view && view.name ? String(view.name) : "");

// Retired 28 Sep 2026, with the group model itself. It named the groups
// behind a merged view ("Lean + Standard - merged from your groups Finance
// and Operations"), read from `view.groups`, which the server stopped
// sending when views replaced groups: it has answered [] ever since. A person
// who holds two views for one database now chooses between them in the bar
// (utils/readingContext.js switcherOptions), so the merged name is the state
// before they choose, not something to explain with group names.
//
// Kept, not deleted, in the codebase's own habit - the line below is what it
// used to build.
//
// export const mergedFrom = (view) => {
//   const groups = Array.isArray(view?.groups) ? view.groups.filter(Boolean) : [];
//   return groups.length >= 2 ? groups : [];
// };
// const listed = (names) =>
//   names.length === 2 ? names.join(" and ") : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
export const mergedFrom = () => [];

// "View: Lean". Empty where no view applies: for a place that already says
// where you are (the database chip in the bar) and needs nothing more.
export const viewLine = (view) => {
  const name = viewName(view);
  return name ? `View: ${name}` : "";
};

// The same, for a line that must say something either way - the greeting on
// Home, and the account menu.
export const viewContextLine = (view) => viewLine(view) || NO_VIEW;
